export const AREAS_MARRIAGE_SITE = [
  {
    name: '札幌駅',
    slug: 'sapporo-sta',
    marriage_site_url: '/kekkon/spots/ag_1'
  },
  {
    name: 'すすきの',
    slug: 'susukino',
    marriage_site_url: '/kekkon/spots/ag_2'
  },
  {
    name: '札幌市内その他',
    slug: 'sapporocity-other',
    marriage_site_url: '/kekkon/spots/ag_3'
  },
  {
    name: '函館市',
    slug: 'hakodate',
    marriage_site_url: '/kekkon/spots/ag_4'
  },
  {
    name: '旭川市',
    slug: 'asahikawa',
    marriage_site_url: '/kekkon/spots/ag_5'
  },
  {
    name: '釧路市',
    slug: 'kushiro',
    marriage_site_url: '/kekkon/spots/ag_6'
  },
  {
    name: '帯広市',
    slug: 'obihiro',
    marriage_site_url: '/kekkon/spots/ag_7'
  },
  {
    name: '北海道その他',
    slug: 'hokkaido-other',
    marriage_site_url: '/kekkon/spots/ag_8'
  },
  {
    name: '仙台市',
    slug: 'sendai',
    marriage_site_url: '/kekkon/spots/ag_16'
  },
  {
    name: '石巻市',
    slug: 'ishinomaki',
    marriage_site_url: '/kekkon/spots/ag_17'
  },
  {
    name: '宮城県その他',
    slug: 'miyagi-other',
    marriage_site_url: '/kekkon/spots/ag_16'
  },
  {
    name: '山形市',
    slug: 'yamagata',
    marriage_site_url: '/kekkon/spots/ag_22'
  },
  {
    name: '鶴岡市',
    slug: 'tsuruoka',
    marriage_site_url: '/kekkon/spots/ag_23'
  },
  {
    name: '山形県その他',
    slug: 'yamagata-other',
    marriage_site_url: '/kekkon/spots/ag_24'
  },
  {
    name: '盛岡市',
    slug: 'morioka',
    marriage_site_url: '/kekkon/spots/ag_13'
  },
  {
    name: '一関市',
    slug: 'ichinoseki',
    marriage_site_url: '/kekkon/spots/ag_14'
  },
  {
    name: '岩手県その他',
    slug: 'iwate-other',
    marriage_site_url: '/kekkon/spots/ag_15'
  },
  {
    name: '郡山市',
    slug: 'koriyama',
    marriage_site_url: '/kekkon/spots/ag_25'
  },
  {
    name: 'いわき市',
    slug: 'iwaki',
    marriage_site_url: '/kekkon/spots/ag_26'
  },
  {
    name: '福島県その他',
    slug: 'fukushima-other',
    marriage_site_url: '/kekkon/spots/ag_27'
  },
  {
    name: '秋田市',
    slug: 'akita',
    marriage_site_url: '/kekkon/spots/ag_19'
  },
  {
    name: '横手市',
    slug: 'yokote',
    marriage_site_url: '/kekkon/spots/ag_20'
  },
  {
    name: '秋田県その他',
    slug: 'akita-other',
    marriage_site_url: '/kekkon/spots/ag_21'
  },
  {
    name: '青森市',
    slug: 'aomori',
    marriage_site_url: '/kekkon/spots/ag_9'
  },
  {
    name: '八戸市',
    slug: 'hachinohe',
    marriage_site_url: '/kekkon/spots/ag_10'
  },
  {
    name: '青森県その他',
    slug: 'aomori-other',
    marriage_site_url: '/kekkon/spots/ag_11'
  },
  {
    name: '弘前市',
    slug: 'hirosaki',
    marriage_site_url: '/kekkon/spots/ag_12'
  },
  {
    name: '丸の内',
    slug: 'marunouchi',
    marriage_site_url: '/kekkon/spots/ag_51'
  },
  {
    name: '大手町',
    slug: 'otemachi',
    marriage_site_url: '/kekkon/spots/ag_52'
  },
  {
    name: '日本橋',
    slug: 'nihonbashi',
    marriage_site_url: '/kekkon/spots/ag_53'
  },
  {
    name: '八重洲/東京駅',
    slug: 'yaesu',
    marriage_site_url: '/kekkon/spots/ag_54'
  },
  {
    name: '有楽町',
    slug: 'yurakucho',
    marriage_site_url: '/kekkon/spots/ag_55'
  },
  {
    name: '銀座',
    slug: 'ginza',
    marriage_site_url: '/kekkon/spots/ag_56'
  },
  {
    name: '飯田橋',
    slug: 'iidabashi',
    marriage_site_url: '/kekkon/spots/ag_57'
  },
  {
    name: '神楽坂',
    slug: 'kagurazaka',
    marriage_site_url: '/kekkon/spots/ag_58'
  },
  {
    name: '秋葉原',
    slug: 'akihabara',
    marriage_site_url: '/kekkon/spots/ag_59'
  },
  {
    name: '神田',
    slug: 'kanda',
    marriage_site_url: '/kekkon/spots/ag_60'
  },
  {
    name: '六本木',
    slug: 'roppongi',
    marriage_site_url: '/kekkon/spots/ag_61'
  },
  {
    name: '赤坂',
    slug: 'akasaka',
    marriage_site_url: '/kekkon/spots/ag_62'
  },
  {
    name: '青山',
    slug: 'aoyama',
    marriage_site_url: '/kekkon/spots/ag_63'
  },
  {
    name: '表参道',
    slug: 'omotesando',
    marriage_site_url: '/kekkon/spots/ag_64'
  },
  {
    name: '原宿',
    slug: 'harajuku',
    marriage_site_url: '/kekkon/spots/ag_65'
  },
  {
    name: '新宿',
    slug: 'shinjuku',
    marriage_site_url: '/kekkon/spots/ag_66'
  },
  {
    name: '上野',
    slug: 'ueno',
    marriage_site_url: '/kekkon/spots/ag_67'
  },
  {
    name: '浅草',
    slug: 'asakusa',
    marriage_site_url: '/kekkon/spots/ag_68'
  },
  {
    name: '品川区',
    slug: 'shinagawa',
    marriage_site_url: '/kekkon/spots/ag_69'
  },
  {
    name: '目黒区',
    slug: 'meguro',
    marriage_site_url: '/kekkon/spots/ag_70'
  },
  {
    name: '中目黒',
    slug: 'nakameguro',
    marriage_site_url: '/kekkon/spots/ag_71'
  },
  {
    name: '自由が丘',
    slug: 'jiyugaoka',
    marriage_site_url: '/kekkon/spots/ag_72'
  },
  {
    name: '恵比寿',
    slug: 'ebisu',
    marriage_site_url: '/kekkon/spots/ag_73'
  },
  {
    name: '代官山',
    slug: 'daikanyama',
    marriage_site_url: '/kekkon/spots/ag_74'
  },
  {
    name: '渋谷区',
    slug: 'shibuya',
    marriage_site_url: '/kekkon/spots/ag_75'
  },
  {
    name: '池袋',
    slug: 'ikebukuro',
    marriage_site_url: '/kekkon/spots/ag_76'
  },
  {
    name: '八王子',
    slug: 'hachioji',
    marriage_site_url: '/kekkon/spots/ag_77'
  },
  {
    name: '立川',
    slug: 'tachikawa',
    marriage_site_url: '/kekkon/spots/ag_78'
  },
  {
    name: '吉祥寺',
    slug: 'kichijoji',
    marriage_site_url: '/kekkon/spots/ag_79'
  },
  {
    name: '町田',
    slug: 'machida',
    marriage_site_url: '/kekkon/spots/ag_80'
  },
  {
    name: '東京都その他',
    slug: 'tokyo-other',
    marriage_site_url: '/kekkon/spots/ag_81'
  },
  {
    name: '横浜駅周辺',
    slug: 'yokohama-sta',
    marriage_site_url: '/kekkon/spots/ag_82'
  },
  {
    name: '関内・桜木町・みなとみらい',
    slug: 'minatomirai',
    marriage_site_url: '/kekkon/spots/ag_83'
  },
  {
    name: '元町・中華街・石川町',
    slug: 'motomachi',
    marriage_site_url: '/kekkon/spots/ag_84'
  },
  {
    name: '横浜市内その他',
    slug: 'yokohamacity-other',
    marriage_site_url: '/kekkon/spots/ag_85'
  },
  {
    name: '川崎市',
    slug: 'kawasaki',
    marriage_site_url: '/kekkon/spots/ag_86'
  },
  {
    name: '相模原市',
    slug: 'sagamihara',
    marriage_site_url: '/kekkon/spots/ag_87'
  },
  {
    name: '鎌倉市',
    slug: 'kamakura',
    marriage_site_url: '/kekkon/spots/ag_88'
  },
  {
    name: '藤沢市',
    slug: 'fujisawa',
    marriage_site_url: '/kekkon/spots/ag_89'
  },
  {
    name: '小田原市',
    slug: 'odawara',
    marriage_site_url: '/kekkon/spots/ag_90'
  },
  {
    name: '神奈川県その他',
    slug: 'kanagawa-other',
    marriage_site_url: '/kekkon/spots/ag_91'
  },
  {
    name: '千葉市',
    slug: 'chiba',
    marriage_site_url: '/kekkon/spots/ag_45'
  },
  {
    name: '幕張',
    slug: 'makuhari',
    marriage_site_url: '/kekkon/spots/ag_46'
  },
  {
    name: '船橋市',
    slug: 'funabashi',
    marriage_site_url: '/kekkon/spots/ag_47'
  },
  {
    name: '柏市',
    slug: 'kashiwa',
    marriage_site_url: '/kekkon/spots/ag_48'
  },
  {
    name: '千葉県その他',
    slug: 'chiba-other',
    marriage_site_url: '/kekkon/spots/ag_49'
  },
  {
    name: '成田市',
    slug: 'narita',
    marriage_site_url: '/kekkon/spots/ag_50'
  },
  {
    name: '大宮区',
    slug: 'omiya',
    marriage_site_url: '/kekkon/spots/ag_39'
  },
  {
    name: '浦和区',
    slug: 'urawa',
    marriage_site_url: '/kekkon/spots/ag_40'
  },
  {
    name: 'さいたま市内その他',
    slug: 'saitamacity-other',
    marriage_site_url: '/kekkon/spots/ag_41'
  },
  {
    name: '川越市',
    slug: 'kawagoe',
    marriage_site_url: '/kekkon/spots/ag_42'
  },
  {
    name: '埼玉県その他',
    slug: 'saitama-other',
    marriage_site_url: '/kekkon/spots/ag_43'
  },
  {
    name: '熊谷市',
    slug: 'kumagaya',
    marriage_site_url: '/kekkon/spots/ag_44'
  },
  {
    name: '前橋市',
    slug: 'maebashi',
    marriage_site_url: '/kekkon/spots/ag_35'
  },
  {
    name: '高崎市',
    slug: 'takasaki',
    marriage_site_url: '/kekkon/spots/ag_36'
  },
  {
    name: '群馬県その他',
    slug: 'gunma-other',
    marriage_site_url: '/kekkon/spots/ag_37'
  },
  {
    name: '太田市',
    slug: 'ota',
    marriage_site_url: '/kekkon/spots/ag_38'
  },
  {
    name: '宇都宮市',
    slug: 'utsunomiya',
    marriage_site_url: '/kekkon/spots/ag_32'
  },
  {
    name: '小山市',
    slug: 'oyama',
    marriage_site_url: '/kekkon/spots/ag_33'
  },
  {
    name: '栃木県その他',
    slug: 'tochigi-other',
    marriage_site_url: '/kekkon/spots/ag_34'
  },
  {
    name: '水戸市',
    slug: 'mito',
    marriage_site_url: '/kekkon/spots/ag_28'
  },
  {
    name: '日立市',
    slug: 'hitachi',
    marriage_site_url: '/kekkon/spots/ag_29'
  },
  {
    name: '茨城県その他',
    slug: 'ibaraki-other',
    marriage_site_url: '/kekkon/spots/ag_30'
  },
  {
    name: 'つくば市',
    slug: 'tsukuba',
    marriage_site_url: '/kekkon/spots/ag_31'
  },
  {
    name: '富山市',
    slug: 'toyama',
    marriage_site_url: '/kekkon/spots/ag_95'
  },
  {
    name: '高岡市',
    slug: 'takaoka',
    marriage_site_url: '/kekkon/spots/ag_96'
  },
  {
    name: '富山県その他',
    slug: 'toyama-other',
    marriage_site_url: '/kekkon/spots/ag_97'
  },
  {
    name: '甲府市',
    slug: 'kofu',
    marriage_site_url: '/kekkon/spots/ag_104'
  },
  {
    name: '甲斐市',
    slug: 'kai',
    marriage_site_url: '/kekkon/spots/ag_105'
  },
  {
    name: '山梨県その他',
    slug: 'yamanashi-other',
    marriage_site_url: '/kekkon/spots/ag_106'
  },
  {
    name: '新潟市',
    slug: 'niigata',
    marriage_site_url: '/kekkon/spots/ag_92'
  },
  {
    name: '長岡市',
    slug: 'nagaoka',
    marriage_site_url: '/kekkon/spots/ag_93'
  },
  {
    name: '新潟県その他',
    slug: 'niigata-other',
    marriage_site_url: '/kekkon/spots/ag_94'
  },
  {
    name: '金沢市',
    slug: 'kanazawa',
    marriage_site_url: '/kekkon/spots/ag_98'
  },
  {
    name: '白山市',
    slug: 'hakusan',
    marriage_site_url: '/kekkon/spots/ag_99'
  },
  {
    name: '石川県その他',
    slug: 'ishikawa-other',
    marriage_site_url: '/kekkon/spots/ag_100'
  },
  {
    name: '福井市',
    slug: 'fukui',
    marriage_site_url: '/kekkon/spots/ag_101'
  },
  {
    name: '越前市',
    slug: 'echizen',
    marriage_site_url: '/kekkon/spots/ag_102'
  },
  {
    name: '福井県その他',
    slug: 'fukui-other',
    marriage_site_url: '/kekkon/spots/ag_103'
  },
  {
    name: '長野市',
    slug: 'nagano',
    marriage_site_url: '/kekkon/spots/ag_107'
  },
  {
    name: '松本市',
    slug: 'matsumoto',
    marriage_site_url: '/kekkon/spots/ag_108'
  },
  {
    name: '上田市',
    slug: 'ueda',
    marriage_site_url: '/kekkon/spots/ag_109'
  },
  {
    name: '長野県その他',
    slug: 'nagano-other',
    marriage_site_url: '/kekkon/spots/ag_110'
  },
  {
    name: '名駅',
    slug: 'nagoya-sta',
    marriage_site_url: '/kekkon/spots/ag_118'
  },
  {
    name: '金山',
    slug: 'kanayama',
    marriage_site_url: '/kekkon/spots/ag_119'
  },
  {
    name: '栄',
    slug: 'sakae',
    marriage_site_url: '/kekkon/spots/ag_120'
  },
  {
    name: '名古屋市内その他',
    slug: 'nagoyacity-other',
    marriage_site_url: '/kekkon/spots/ag_121'
  },
  {
    name: '豊橋市',
    slug: 'toyohashi',
    marriage_site_url: '/kekkon/spots/ag_122'
  },
  {
    name: '岡崎市',
    slug: 'okazaki',
    marriage_site_url: '/kekkon/spots/ag_123'
  },
  {
    name: '豊田市',
    slug: 'toyota',
    marriage_site_url: '/kekkon/spots/ag_124'
  },
  {
    name: '一宮市',
    slug: 'ichinomiya',
    marriage_site_url: '/kekkon/spots/ag_125'
  },
  {
    name: '犬山市',
    slug: 'inuyama',
    marriage_site_url: '/kekkon/spots/ag_126'
  },
  {
    name: '愛知県その他',
    slug: 'aichi-other',
    marriage_site_url: '/kekkon/spots/ag_127'
  },
  {
    name: '刈谷市',
    slug: 'kariya',
    marriage_site_url: '/kekkon/spots/ag_128'
  },
  {
    name: '静岡市',
    slug: 'shizuoka',
    marriage_site_url: '/kekkon/spots/ag_114'
  },
  {
    name: '浜松市',
    slug: 'hamamatsu',
    marriage_site_url: '/kekkon/spots/ag_115'
  },
  {
    name: '沼津市',
    slug: 'numazu',
    marriage_site_url: '/kekkon/spots/ag_116'
  },
  {
    name: '静岡県その他',
    slug: 'shizuoka-other',
    marriage_site_url: '/kekkon/spots/ag_117'
  },
  {
    name: '津市',
    slug: 'tsu',
    marriage_site_url: '/kekkon/spots/ag_129'
  },
  {
    name: '四日市市',
    slug: 'yokkaichi',
    marriage_site_url: '/kekkon/spots/ag_130'
  },
  {
    name: '三重県その他',
    slug: 'mie-other',
    marriage_site_url: '/kekkon/spots/ag_131'
  },
  {
    name: '岐阜市',
    slug: 'gifu',
    marriage_site_url: '/kekkon/spots/ag_111'
  },
  {
    name: '大垣市',
    slug: 'ogaki',
    marriage_site_url: '/kekkon/spots/ag_112'
  },
  {
    name: '岐阜県その他',
    slug: 'gifu-other',
    marriage_site_url: '/kekkon/spots/ag_113'
  },
  {
    name: '梅田',
    slug: 'umeda',
    marriage_site_url: '/kekkon/spots/ag_140'
  },
  {
    name: '茶屋町',
    slug: 'chayamachi',
    marriage_site_url: '/kekkon/spots/ag_141'
  },
  {
    name: '堂島',
    slug: 'dojima',
    marriage_site_url: '/kekkon/spots/ag_142'
  },
  {
    name: '天満',
    slug: 'tenma',
    marriage_site_url: '/kekkon/spots/ag_143'
  },
  {
    name: '福島区',
    slug: 'fukushima',
    marriage_site_url: '/kekkon/spots/ag_144'
  },
  {
    name: '心斎橋',
    slug: 'shinsaibashi',
    marriage_site_url: '/kekkon/spots/ag_145'
  },
  {
    name: '難波',
    slug: 'namba',
    marriage_site_url: '/kekkon/spots/ag_146'
  },
  {
    name: '堀江',
    slug: 'horie',
    marriage_site_url: '/kekkon/spots/ag_147'
  },
  {
    name: '本町',
    slug: 'honmachi',
    marriage_site_url: '/kekkon/spots/ag_148'
  },
  {
    name: '天王寺区',
    slug: 'tennoji',
    marriage_site_url: '/kekkon/spots/ag_149'
  },
  {
    name: '新大阪',
    slug: 'shinosaka',
    marriage_site_url: '/kekkon/spots/ag_150'
  },
  {
    name: '大阪府北部その他',
    slug: 'osakanorth-other',
    marriage_site_url: '/kekkon/spots/ag_151'
  },
  {
    name: '堺市',
    slug: 'sakai',
    marriage_site_url: '/kekkon/spots/ag_152'
  },
  {
    name: '大阪府南部その他',
    slug: 'osakasouth-other',
    marriage_site_url: '/kekkon/spots/ag_153'
  },
  {
    name: '大阪府その他',
    slug: 'osaka-other',
    marriage_site_url: '/kekkon/spots/ag_154'
  },
  {
    name: '三宮・元町',
    slug: 'sannomiya',
    marriage_site_url: '/kekkon/spots/ag_155'
  },
  {
    name: '神戸市内その他',
    slug: 'kobecity-other',
    marriage_site_url: '/kekkon/spots/ag_156'
  },
  {
    name: '姫路市',
    slug: 'himeji',
    marriage_site_url: '/kekkon/spots/ag_157'
  },
  {
    name: '尼崎市',
    slug: 'amagasaki',
    marriage_site_url: '/kekkon/spots/ag_158'
  },
  {
    name: '西宮市',
    slug: 'nishinomiya',
    marriage_site_url: '/kekkon/spots/ag_159'
  },
  {
    name: '兵庫県その他',
    slug: 'hyogo-other',
    marriage_site_url: '/kekkon/spots/ag_160'
  },
  {
    name: '河原町',
    slug: 'kawaramachi',
    marriage_site_url: '/kekkon/spots/ag_135'
  },
  {
    name: '烏丸',
    slug: 'karasuma',
    marriage_site_url: '/kekkon/spots/ag_136'
  },
  {
    name: '京都駅周辺',
    slug: 'kyoto-sta',
    marriage_site_url: '/kekkon/spots/ag_137'
  },
  {
    name: '京都市内その他',
    slug: 'kyotocity-other',
    marriage_site_url: '/kekkon/spots/ag_138'
  },
  {
    name: '京都府その他',
    slug: 'kyoto-other',
    marriage_site_url: '/kekkon/spots/ag_139'
  },
  {
    name: '和歌山市',
    slug: 'wakayama',
    marriage_site_url: '/kekkon/spots/ag_164'
  },
  {
    name: '田辺市',
    slug: 'tanabe',
    marriage_site_url: '/kekkon/spots/ag_165'
  },
  {
    name: '和歌山県その他',
    slug: 'wakayama-other',
    marriage_site_url: '/kekkon/spots/ag_166'
  },
  {
    name: '奈良市',
    slug: 'nara',
    marriage_site_url: '/kekkon/spots/ag_161'
  },
  {
    name: '橿原市',
    slug: 'kashihara',
    marriage_site_url: '/kekkon/spots/ag_162'
  },
  {
    name: '奈良県その他',
    slug: 'nara-other',
    marriage_site_url: '/kekkon/spots/ag_163'
  },
  {
    name: '大津市',
    slug: 'otsu',
    marriage_site_url: '/kekkon/spots/ag_132'
  },
  {
    name: '草津市',
    slug: 'kusatsu',
    marriage_site_url: '/kekkon/spots/ag_133'
  },
  {
    name: '滋賀県その他',
    slug: 'shiga-other',
    marriage_site_url: '/kekkon/spots/ag_134'
  },
  {
    name: '下関市',
    slug: 'shimonoseki',
    marriage_site_url: '/kekkon/spots/ag_183'
  },
  {
    name: '山口市',
    slug: 'yamaguchi',
    marriage_site_url: '/kekkon/spots/ag_184'
  },
  {
    name: '山口県その他',
    slug: 'yamaguchi-other',
    marriage_site_url: '/kekkon/spots/ag_185'
  },
  {
    name: '岡山駅周辺',
    slug: 'okayama-sta',
    marriage_site_url: '/kekkon/spots/ag_173'
  },
  {
    name: '表町・田町',
    slug: 'omotecho',
    marriage_site_url: '/kekkon/spots/ag_174'
  },
  {
    name: '岡山市内その他',
    slug: 'okayamacity-other',
    marriage_site_url: '/kekkon/spots/ag_175'
  },
  {
    name: '倉敷市',
    slug: 'kurashiki',
    marriage_site_url: '/kekkon/spots/ag_176'
  },
  {
    name: '岡山県その他',
    slug: 'okayama-other',
    marriage_site_url: '/kekkon/spots/ag_177'
  },
  {
    name: '松江市',
    slug: 'matsue',
    marriage_site_url: '/kekkon/spots/ag_170'
  },
  {
    name: '出雲市',
    slug: 'izumo',
    marriage_site_url: '/kekkon/spots/ag_171'
  },
  {
    name: '島根県その他',
    slug: 'shimane-other',
    marriage_site_url: '/kekkon/spots/ag_172'
  },
  {
    name: '八丁堀・紙屋町',
    slug: 'hacchobori',
    marriage_site_url: '/kekkon/spots/ag_178'
  },
  {
    name: '広島駅周辺',
    slug: 'hiroshima-sta',
    marriage_site_url: '/kekkon/spots/ag_179'
  },
  {
    name: '広島市内その他',
    slug: 'hiroshimacity-other',
    marriage_site_url: '/kekkon/spots/ag_180'
  },
  {
    name: '福山市',
    slug: 'fukuyama',
    marriage_site_url: '/kekkon/spots/ag_181'
  },
  {
    name: '広島県その他',
    slug: 'hiroshima-other',
    marriage_site_url: '/kekkon/spots/ag_182'
  },
  {
    name: '鳥取市',
    slug: 'tottori',
    marriage_site_url: '/kekkon/spots/ag_167'
  },
  {
    name: '米子市',
    slug: 'yonago',
    marriage_site_url: '/kekkon/spots/ag_168'
  },
  {
    name: '鳥取県その他',
    slug: 'tottori-other',
    marriage_site_url: '/kekkon/spots/ag_169'
  },
  {
    name: '徳島市',
    slug: 'tokushima',
    marriage_site_url: '/kekkon/spots/ag_186'
  },
  {
    name: '阿南市',
    slug: 'anan',
    marriage_site_url: '/kekkon/spots/ag_187'
  },
  {
    name: '徳島県その他',
    slug: 'tokushima-other',
    marriage_site_url: '/kekkon/spots/ag_188'
  },
  {
    name: '松山市',
    slug: 'matsuyama',
    marriage_site_url: '/kekkon/spots/ag_192'
  },
  {
    name: '今治市',
    slug: 'imabari',
    marriage_site_url: '/kekkon/spots/ag_193'
  },
  {
    name: '愛媛県その他',
    slug: 'ehime-other',
    marriage_site_url: '/kekkon/spots/ag_194'
  },
  {
    name: '高松市',
    slug: 'takamatsu',
    marriage_site_url: '/kekkon/spots/ag_189'
  },
  {
    name: '丸亀市',
    slug: 'marugame',
    marriage_site_url: '/kekkon/spots/ag_190'
  },
  {
    name: '香川県その他',
    slug: 'kagawa-other',
    marriage_site_url: '/kekkon/spots/ag_191'
  },
  {
    name: '高知市',
    slug: 'kochi',
    marriage_site_url: '/kekkon/spots/ag_195'
  },
  {
    name: '南国市',
    slug: 'nankoku',
    marriage_site_url: '/kekkon/spots/ag_196'
  },
  {
    name: '高知県その他',
    slug: 'kochi-other',
    marriage_site_url: '/kekkon/spots/ag_197'
  },
  {
    name: '北九州市',
    slug: 'kitakyushu',
    marriage_site_url: '/kekkon/spots/ag_198'
  },
  {
    name: '小倉区',
    slug: 'kokura',
    marriage_site_url: '/kekkon/spots/ag_199'
  },
  {
    name: '博多区',
    slug: 'hakata',
    marriage_site_url: '/kekkon/spots/ag_200'
  },
  {
    name: '天神',
    slug: 'tenjin',
    marriage_site_url: '/kekkon/spots/ag_201'
  },
  {
    name: '久留米市',
    slug: 'kurume',
    marriage_site_url: '/kekkon/spots/ag_203'
  },
  {
    name: '福岡県その他',
    slug: 'fukuoka-other',
    marriage_site_url: '/kekkon/spots/ag_204'
  },
  {
    name: '長崎市',
    slug: 'nagasaki',
    marriage_site_url: '/kekkon/spots/ag_208'
  },
  {
    name: '佐世保市',
    slug: 'sasebo',
    marriage_site_url: '/kekkon/spots/ag_209'
  },
  {
    name: '長崎県その他',
    slug: 'nagasaki-other',
    marriage_site_url: '/kekkon/spots/ag_210'
  },
  {
    name: '佐賀市',
    slug: 'saga',
    marriage_site_url: '/kekkon/spots/ag_205'
  },
  {
    name: '鳥栖市',
    slug: 'tosu',
    marriage_site_url: '/kekkon/spots/ag_206'
  },
  {
    name: '佐賀県その他',
    slug: 'saga-other',
    marriage_site_url: '/kekkon/spots/ag_207'
  },
  {
    name: '大分市',
    slug: 'oita',
    marriage_site_url: '/kekkon/spots/ag_214'
  },
  {
    name: '別府市',
    slug: 'beppu',
    marriage_site_url: '/kekkon/spots/ag_215'
  },
  {
    name: '大分県その他',
    slug: 'oita-other',
    marriage_site_url: '/kekkon/spots/ag_216'
  },
  {
    name: '宮崎市',
    slug: 'miyazaki',
    marriage_site_url: '/kekkon/spots/ag_217'
  },
  {
    name: '都城市',
    slug: 'miyakonojo',
    marriage_site_url: '/kekkon/spots/ag_218'
  },
  {
    name: '宮崎県その他',
    slug: 'miyazaki-other',
    marriage_site_url: '/kekkon/spots/ag_219'
  },
  {
    name: '熊本市',
    slug: 'kumamoto',
    marriage_site_url: '/kekkon/spots/ag_211'
  },
  {
    name: '八代市',
    slug: 'yatsushiro',
    marriage_site_url: '/kekkon/spots/ag_212'
  },
  {
    name: '熊本県その他',
    slug: 'kumamoto-other',
    marriage_site_url: '/kekkon/spots/ag_213'
  },
  {
    name: '鹿児島市',
    slug: 'kagoshima',
    marriage_site_url: '/kekkon/spots/ag_220'
  },
  {
    name: '霧島市',
    slug: 'kirishima',
    marriage_site_url: '/kekkon/spots/ag_221'
  },
  {
    name: '鹿児島県その他',
    slug: 'kagoshima-other',
    marriage_site_url: '/kekkon/spots/ag_222'
  },
  {
    name: '那覇市',
    slug: 'naha',
    marriage_site_url: '/kekkon/spots/ag_223'
  },
  {
    name: '沖縄',
    slug: 'okinawa',
    marriage_site_url: '/kekkon/spots/ag_224'
  },
  {
    name: '沖縄県その他',
    slug: 'okinawa-other',
    marriage_site_url: '/kekkon/spots/ag_225'
  },
  {
    name: 'その他',
    slug: 'other',
    marriage_site_url: '/kekkon/spots/ag_226'
  }
]
